//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Bar, Line} from 'react-chartjs-2'
import ProgressBar from 'react-bootstrap/ProgressBar'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../graphcardCommon.scss'

// @ADD Component types
interface IGraphcardCommonLayoutProps {
	title?: string,
  type: 'bars' | 'line' | 'progress',
  data: any
  options?: any
}

const GraphcardCommonLayout: React.FC<IGraphcardCommonLayoutProps> = (props) => {

  const { t } = useTranslation()
  const { title, type } = props

  return(
    <div className='graph-card'>
    	<div className="containerGraph">
    		{
    			(type === 'line') ?
    				(<Line
              data={props.data}
              width={250}
              height={250}
              type='line'
              options={props.options}
           	/>) : null
    		}
    		{
    			(type === 'bars') ?
    				(<Bar
              data={props.data}
              width={250}
              height={250}
              type='bar'
              options={props.options}
           	/>) : null
    		}
    		{
    			(type === 'progress') ?
    				<div className="graphic-progress">
    					<div className="graphic-progress-container">
                {props.data.title && (
                  <div className="title">
                    {props.data.title}
                  </div>
                )}
    						<div className="progress-item">
    							<ProgressBar now={props.data.value} label={`${props.data.value}%`} />
    						</div>
    					</div>
    				</div>
    				: null
    		}
    	</div>
    </div>
  )
}

export default GraphcardCommonLayout
